/**
 * Autocomplete Templates
 * Template functions for search autocomplete dropdown
 */

window.theme = window.theme || {};
window.theme.tagalys = window.theme.tagalys || {};
window.theme.tagalys.searchAutocomplete = window.theme.tagalys.searchAutocomplete || {};
window.theme.tagalys.searchAutocomplete.templates = window.theme.tagalys.searchAutocomplete.templates || {};
window.theme.tagalys.searchAutocomplete.translations = window.theme.tagalys.searchAutocomplete.translations || {};

(function(templates) {

  const translations = window.theme.tagalys.searchAutocomplete.translations;

  /* ==========================================================================
     Suggested Keywords Template
     ========================================================================== */

  templates.buildSuggestedKeywords = function(keywords, searchTerm) {
    const marketUrl = window.location.origin + window.Shopify.routes.root
    return `
      <div class="hd-SearchDropdown_Terms">
        <h3 class="hd-SearchDropdown_SubHeading">${translations.searchSuggestions}</h3>
        <ul class="hd-SearchDropdown_TermList">
          ${keywords.map(keyword => {
            const highlightedKeyword = keyword.query.replace(
              new RegExp(`(${searchTerm})`, 'gi'),
              '<strong>$1</strong>',
            )
            return `
              <li class="hd-SearchDropdown_TermItem">
                <a href="${marketUrl}search?q=${encodeURIComponent(keyword.query)}" data-search-dropdown-el="keyword" class="hd-SearchDropdown_TermLink">
                  ${highlightedKeyword}
                </a>
              </li>
            `
          }).join('')}
        </ul>
      </div>
    `
  };

  /* ==========================================================================
     Results List Template
     ========================================================================== */

  templates.buildResultsList = function(products, term, templateProductCard) {
    const marketUrl = window.location.origin + window.Shopify.routes.root
    return `
      <h3 class="hd-SearchDropdown_SubHeading">${translations.productMatches}</h3>
      <a href="${marketUrl}search?q=${encodeURIComponent(term)}" data-search-dropdown-el="viewAll" class="hd-SearchDropdown_CollectionViewAll">${translations.viewAll}</a>
      <ul class="hd-SearchDropdown_Grid">
        ${products.map(product => {
          const productWithRoot = {
            ...product,
            root: 'autocomplete',
          }

          const clone = document.importNode(templateProductCard.content, true)
          const productCard = clone.querySelector('product-card')
          productCard.setAttribute('data-prop-data', JSON.stringify(productWithRoot))

          const tempContainer = document.createElement('div')
          tempContainer.appendChild(clone)

          return `
            <li class="hd-SearchDropdown_Item">
              ${tempContainer.querySelector('product-card').outerHTML}
            </li>
          `
        }).join('')}
      </ul>
      <a href="${marketUrl}search?q=${encodeURIComponent(term)}" data-search-dropdown-el="viewAllSecondary" class="hd-SearchDropdown_CollectionViewAllSecondary">${translations.viewAll}</a>
    `
  };

  templates.buildPopularTerms = function(terms) {
    const marketUrl = window.location.origin + window.Shopify.routes.root
    return `
        <h3 class="hd-SearchDropdown_SubHeading">${translations.popularSearches}</h3>
        <ul class="hd-SearchDropdown_TermList" data-search-dropdown-el="initial-view-popular">
          ${terms.map(term => {
            return `
              <li class="hd-SearchDropdown_TermItem">
                <a href="${marketUrl}search/?q=${encodeURIComponent(term.query)}" data-search-dropdown-el="keyword" class="hd-SearchDropdown_TermLink">
                  ${term.query}
                </a>
              </li>
            `
          }).join('')}
        </ul>
    `
  };

})(window.theme.tagalys.searchAutocomplete.templates);
